import UsersTable from "../../Components/UsersTable";

const Users = () => {
    return (
        <UsersTable></UsersTable>
    );
}

export default Users;